import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import FooterDots from '@themes/architectui/src/Layout/Components//Footer/FooterDots.vue';
import FooterMenu from '@themes/architectui/src/Layout/Components//Footer/FooterMenu.vue';

@Component({
  name: 'bpc-footer',
  components: {
    FooterDots,
    FooterMenu,
  },
})
export default class Footer extends Vue {
  get isRoleContact() {
    return this.$authorizationService.hasRole('contact');
  }
  get showTranslationReport(): boolean {
    return process.env.VUE_APP_ACTIVATE_TRANSLATION_REPORTS === 'true';
  }
  get showTranslationCSVMenu(): boolean {
    return process.env.VUE_APP_ACTIVATE_TRANSLATION_CSV_MENU === 'true';
  }
}
